import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {
	return {
		descContainer: {
			display  : "block",
			maxWidth : "100%",
			padding  : "0 0 1rem 0"
		},
		descriptionBroadcast: {
			textAlign       : "left",
			display         : "-webkit-box",
			marginBottom    : "2px",
			paddingBottom   : "2px",
			WebkitBoxOrient : "vertical",
			WebkitLineClamp : "2",
			overflow        : "hidden",
			whiteSpace      : "pre-wrap"
		},
		fullDescriptionBroadcast: {
			textAlign     : "left",
			display       : "-webkit-box",
			marginBottom  : "2px",
			paddingBottom : "2px",
			whiteSpace    : "pre-wrap"
		},
		seeBtn: {
			textAlign : "left",
			color     : "#757575",
			cursor    : "pointer"
		}
	};
} );

